var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderIconCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand=SV"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.186981 25.8621C2.70784 34.0467 10.3684 40 19.4303 40C30.5444 40 39.5533 31.0463 39.5544 19.9994C39.5544 8.95483 30.5444 0 19.4314 0C10.1285 0 2.3046 6.27382 0 14.7971C2.26517 16.1744 4.16089 18.0977 5.49341 20.3868C4.19806 22.6125 2.37105 24.4916 0.186981 25.8621ZM5.5182 20.3868C8.27223 15.6568 13.4165 12.474 19.3109 12.474C25.2042 12.474 30.3506 15.6568 33.1035 20.3868C30.3495 25.1179 25.2042 28.3007 19.3109 28.3007C13.4165 28.3007 8.2711 25.1179 5.5182 20.3868Z",
    fill: "#9CA0A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderIconCard);
export default __webpack_public_path__ + "static/media/placeholder_icon_card.fd6bb2d17c93dc4791a72d7cd3f0a763.svg";
export { ForwardRef as ReactComponent };